<div class="flex justify-between items-center mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Editar OS {{ item.codigoOs }}
  </div>
</div>

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
  <div [formGroup]="form">
    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-6/12"
        appearance="outline"
      >
        <mat-label>Fornecedor</mat-label>
        <mat-select formControlName="fornecedorId">
          @for (supplier of suppliers; track supplier.id) {
            <mat-option [value]="supplier.id">
              {{ supplier.nomeFantasia ?? supplier.nome ?? supplier.razaoSocial }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Valor tarifário</mat-label>
        <input
          matInput
          [value]="cos?.valorTarifario ?? '-'"
          readonly
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-3/12"
        appearance="outline"
      >
        <mat-label>Prazo de pagamento</mat-label>
        <input
          matInput
          [value]="
            prazoPagamentoSelecionado != null
              ? prazoPagamentoSelecionado + ' dias'
              : '-'
          "
          readonly
        />
      </mat-form-field>
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Tipo de veículo</mat-label>
        <input
          matInput
          [value]="item.descricaoTipoVeiculo ?? '-'"
          readonly
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Tipo de motorista</mat-label>
        <input
          matInput
          [value]="item.descricaoTipoMotorista ?? '-'"
          readonly
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Status da compra</mat-label>
        <input
          matInput
          [value]="cos?.descricaoStatusCompra ?? '-'"
          readonly
        />
      </mat-form-field>
    </div>

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Valor unitário motorista</mat-label>
        <input
          matInput
          currencyInput
          formControlName="valorUnitarioMotorista"
        />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Valor unitário veículo</mat-label>
        <input matInput currencyInput formControlName="valorUnitarioVeiculo" />
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Valor de custo</mat-label>
        <input matInput currencyInput formControlName="valorCusto" />
      </mat-form-field>
    </div>

    @if (isGestor) {
      <div class="mb-3 flex justify-between items-center gap-3">
        <mat-form-field
          class="input-tg search-tg no-message-new w-4/12"
          appearance="outline"
        >
          <mat-label>Multiplicador margem</mat-label>
          <input
            matInput
            type="number"
            step="0.01"
            formControlName="multiplicadorMargem"
          />
        </mat-form-field>

        <mat-form-field
          class="input-tg search-tg no-message-new w-4/12"
          appearance="outline"
        >
          <mat-label>Target</mat-label>
          <input matInput [value]="targetDisplay" readonly />
        </mat-form-field>

        <mat-form-field
          class="input-tg search-tg no-message-new w-4/12"
          appearance="outline"
        >
          <mat-label>Savings</mat-label>
          <input matInput [value]="savingsDisplay" readonly />
        </mat-form-field>
      </div>
    }

    <div class="mb-3 flex justify-between items-center gap-3">
      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Observação logística</mat-label>
        <textarea matInput [value]="cos?.obsLogistica ?? ''" readonly></textarea>
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Observação ao cliente</mat-label>
        <textarea matInput formControlName="obsCliente"></textarea>
      </mat-form-field>

      <mat-form-field
        class="input-tg search-tg no-message-new w-4/12"
        appearance="outline"
      >
        <mat-label>Observação ao fornecedor</mat-label>
        <textarea matInput formControlName="obsFornecedorOperador"></textarea>
      </mat-form-field>
    </div>

    <div class="mb-3">
      <mat-checkbox formControlName="enviarEmail"
        >Enviar e-mail de confirmação ao fornecedor</mat-checkbox
      >
    </div>

    <div class="flex justify-end items-center gap-2">
      <button mat-flat-button class="btn-tg-white" (click)="close()" [disabled]="saving">
        Cancelar
      </button>
      <button mat-flat-button class="btn-tg" (click)="save()" [disabled]="saving">
        @if (saving) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Salvar
        }
      </button>
    </div>
  </div>
}
